var _regeneratorRuntime = require("/workspace/node_modules/@babel/runtime/regenerator/index.js");
var _asyncToGenerator = require("/workspace/node_modules/@babel/runtime/helpers/asyncToGenerator.js");
var map = require('ramda/src/map');
var keys = require('ramda/src/keys');
var onSettledSuccess = function onSettledSuccess(value) {
  return {
    state: 'fulfilled',
    value: value
  };
};
var onSettledReject = function onSettledReject(reason) {
  return {
    state: 'rejected',
    reason: reason
  };
};
var onSettledP = function onSettledP(promise) {
  return promise.then(onSettledSuccess, onSettledReject);
};
var resolveProps = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(obj) {
    var result, promises;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            result = {};
            promises = map( /*#__PURE__*/function () {
              var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(key) {
                return _regeneratorRuntime.wrap(function _callee$(_context) {
                  while (1) {
                    switch (_context.prev = _context.next) {
                      case 0:
                        _context.next = 2;
                        return onSettledP(obj[key]);
                      case 2:
                        result[key] = _context.sent;
                      case 3:
                      case "end":
                        return _context.stop();
                    }
                  }
                }, _callee);
              }));
              return function (_x2) {
                return _ref2.apply(this, arguments);
              };
            }(), keys(obj));
            _context2.next = 4;
            return Promise.all(promises);
          case 4:
            return _context2.abrupt("return", result);
          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return function resolveProps(_x) {
    return _ref.apply(this, arguments);
  };
}();

/**
 * A 'promise all' that does not reject when promises are rejected. Instead returns an array of
 * results. Each result will be an object. The object will have the following form for a
 * successfully settled promise:
 * { state: 'fulfilled', value: <the result of the promise> }
 * A rejected result will look like:
 * { state: 'rejected', reason: <the rejection reason/error> }
 *
 * Similar to [this](https://github.com/kriskowal/q/wiki/API-Reference#promiseallsettled).
 *
 * @func
 * @memberof module:omnibelt
 * @name allSettledP

 * @param {Array} promises - An array of promises
 * @return {Promise} A promise that will resolve to an array of settled/rejected results
 * @summary [Promise] -> Promise<[Object]>
 *
 * @example
 * await allSettledP([Promise.resolve('good'), Promise.reject('bad')]);
 * // => [{ state: 'fulfilled', value: 'good' }, { state: 'rejected', reason: 'bad' }]
 */
var allSettledP = function allSettledP(iterable) {
  if (!iterable) {
    return iterable;
  }
  if (Array.isArray(iterable)) {
    return Promise.all(map(onSettledP, iterable));
  } else if (typeof iterable === 'object') {
    return resolveProps(iterable);
  } else {
    return iterable;
  }
};
module.exports = allSettledP;